import {ButtonProps, withTheme} from '@rneui/themed';

import Button from '../ui-controls/Button';

// withTheme wants a component that also takes its ThemeProps (not exported by @rneui),
// and our Button narrows `children` to ReactNode. Cast to the exact parameter type.
export default withTheme<ButtonProps>(
  Button as Parameters<typeof withTheme<ButtonProps>>[0],
  'LMGButton',
);

declare module '@rneui/themed' {
  export interface ComponentTheme {
    LMGButton: Partial<
      ButtonProps & {
        secondary?: boolean;
        variant?: 'text' | 'outlined' | 'contained';
      }
    >;
  }
}
